import { Text, Link, useIsDesignLanguage, DesignLanguage } from '@afterpaytouch/core'
import React, { FunctionComponent } from 'react'

import { useCheckoutSizes } from '../../utils/responsive'
import { useTranslation } from '../../utils/convergence'

import styles from './style.module.css'
import { useMonitoringWithEnduringEventProperties } from '../../integrations/monitoring'
import { useMobileLogin, useIsRoute } from '../../state'
import { Route } from '../../config/router'

interface LoginHelpLinkProps {
  pageName: string
}

export const LoginHelpLink: FunctionComponent<LoginHelpLinkProps> = ({ pageName }) => {
  const { t } = useTranslation()
  const isEnterPasswordRoute = useIsRoute(Route.ENTER_PASSWORD)
  const { textSize } = useCheckoutSizes()
  const isArcadeDesignLanguage = useIsDesignLanguage(DesignLanguage.Arcade)
  const { logEvent } = useMonitoringWithEnduringEventProperties()
  const { isMobileLogin } = useMobileLogin()

  const handleOnClick = (): void => {
    logEvent(`Pressed ${pageName} Need Help`)
  }

  return (
    <>
      {isMobileLogin && (
        <div className={styles.helpLinkWrapper}>
          <Link target='_blank' kind='Underline' href={t('login:helpArticleUrl')} onClick={handleOnClick}>
            <Text size={textSize} bold color={isArcadeDesignLanguage ? 'Inverse Dark' : undefined}>
              {isEnterPasswordRoute ? t('password:needHelpLink') : t('login:helpArticleLinkText')}
            </Text>
          </Link>
        </div>
      )}
    </>
  )
}
